export const themeFont = 'Inter';